import { isAdmin } from "../config";

export function setDocumentTitle(title: string) {
  document.title = `${title} | CVアップ自動化` + (isAdmin ? "管理画面" : "");
}
